import styled from 'styled-components';
import {getToken} from '@tickchak/react-share/app';
import {mobileMedia} from '../../globalVariables/GlobalVariables';
import {dFlex, dFlexColumn, flexWrap} from '../../globalVariables/GlobalFlex';

export const container = styled.div`
    ${dFlexColumn};
    gap: var(--space-md);
    width: 100%;
    margin-top: var(--space-lg);
    ${mobileMedia} {
        margin-top: var(--space-md);
    }
`;

export const wrapper = styled.div<{$hasError?: boolean}>`
    position: relative;
    overflow: hidden;
    border: 2px solid ${p => p.$hasError ? getToken('color.state.error.main') : getToken('color.brand.main')};
    border-radius: var(--border-radius-border-radius-2xl);
    ${mobileMedia} {
        border-radius: var(--border-radius-border-radius-xl);
    }
    ${p => (p.theme?.rtl && p.theme.direction === 'ltr') || (!p.theme?.rtl && p.theme.direction === 'rtl') ? 'direction: ltr;' : 'direction: rtl;'};
`;

export const contentArea = styled.div`
    ${dFlexColumn};
    width: 100%;
`;

export const paragraphsContainer = styled.div`
    flex: 1;
    ${dFlexColumn};
`;

export const toolbar = styled.div`
    ${dFlex};
    ${flexWrap};
    gap: var(--space-sm);
`;